<template>
    <div :class="'coverButton '+(isActive?'active':'inActive')" 
        :style="'left:'+InstanceData.left+';'+
        'top:'+InstanceData.top+';'+
        'width:'+InstanceData.width+';'+
        'height:'+InstanceData.height+';'+
        (InstanceData.minWidth?('min-width:'+InstanceData.minWidth+';'):'')+
        (InstanceData.maxHeight?('max-height:'+InstanceData.maxHeight+';'):'')+
        (InstanceData.scale?('transform:scale('+InstanceData.scale+');'):'')">
        <div v-if="InstanceData.generateButton" @click="sendEvent" class="desktopGeneratedOverlayButton">{{InstanceData.name}}</div>
        <img v-else class="floatingButton" 
        @click="sendEvent" 
        :src="('.'+InstanceData.image)" 
        />
        <img class="crossButton" 
        @click="closeEvent" 
        :style="'right:'+(InstanceData.buttonRight?InstanceData.buttonRight:'10px')+';'+
        'top:'+(InstanceData.buttonTop?InstanceData.buttonTop:'10px')+';'+
        'width:'+(InstanceData.buttonWidth?InstanceData.buttonWidth:'14px')+';'+
        'height:'+(InstanceData.buttonHeight?InstanceData.buttonHeight:'14px')+';'"
        :src="InstanceData.crossImage" 
        />
    </div>
</template>

<script>
import Vue from 'vue'
import "../scss/button-content.css";
export default {
  props: {
    InstanceData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
        isActive:false
    };
  },
  created(){
      if(this.InstanceData.crossImage==null){
        Vue.set(this.InstanceData, "crossImage", '/buttons/svg_cross.svg');
      }
  },
  methods: {
    sendEvent(){
        let customEvent = new CustomEvent(this.InstanceData.buttonType + 'ButtonEvent',{
            detail: { 
                state:"clicked",
                data: this.InstanceData
            }
        });
        window.dispatchEvent(customEvent)

        if(this.InstanceData.link!=null){
            let customEvent = new CustomEvent('openLink',{
                detail: { 
                    routeLink: this.InstanceData.link,
                    alertText: this.InstanceData.alertText?this.InstanceData.alertText:null
                }
            });
            window.dispatchEvent(customEvent)
        }
    },
    setActive(){
        let customEvent = new CustomEvent(this.InstanceData.buttonType + 'ButtonEvent',{
            detail: { 
                state:"visible",
                data: this.InstanceData
            }
        });
        window.dispatchEvent(customEvent)
        this.isActive= true
    },
    setInActive(){
        let customEvent = new CustomEvent(this.InstanceData.buttonType + 'ButtonEvent',{
            detail: { 
                state:"hidden",
                data: this.InstanceData
            }
        });
        window.dispatchEvent(customEvent)
        this.isActive= false
    },
    closeEvent(){
        this.$emit("setChildInactive",this);
    }
  },
};
</script>